import { render } from "./ShopProfit.vue?vue&type=template&id=5c4d7bc2&scoped=true"
import script from "./ShopProfit.vue?vue&type=script&lang=js"
export * from "./ShopProfit.vue?vue&type=script&lang=js"

import "./ShopProfit.vue?vue&type=style&index=0&id=5c4d7bc2&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4d7bc2"]])

export default __exports__